<template>
    <div class="ProfessionalProfessional">
        <el-dialog title="详情" :visible.sync="ReviewBlon" width="60%" :show-close="true">
            <div class="CommDig">
                <div v-if="reviewInfo.personnel.remark" class="TitleBox" style="margin-top: 20px;">
                    <span>驳回备注</span>
                </div>
                <div v-if="reviewInfo.personnel.remark" class="ZhuanYeBoxInfo">
                    <el-input size="small" type="textarea" :rows="3" v-model="reviewInfo.personnel.remark" disabled></el-input>
                </div>
                <div class="TitleBox">
                    <span>基本信息</span>
                </div>
                <table width="100%" class="Table" v-if="reviewInfo.personnel">
                    <tbody>
                        <tr>
                            <td width="10%"><span class="Red">*</span>姓名</td>
                            <td width="23%"><el-input size="small" v-model="reviewInfo.personnel.name"
                                    disabled></el-input></td>
                            <td width="10%"><span class="Red">*</span>手机号</td>
                            <td width="23%"><el-input size="small" v-model="reviewInfo.personnel.mobile"
                                    disabled></el-input>
                            </td>
                            <td colspan="2">
                                <label style="margin-right: 10px;"><span class="Red">*</span>是否向公众公布您的联系方式</label>
                                <el-radio-group disabled v-model="reviewInfo.personnel.is_public" size="small">
                                    <el-radio :label="1">是</el-radio>
                                    <el-radio :label="2">否</el-radio>
                                </el-radio-group>
                            </td>
                        </tr>
                        <tr>
                            <td width="10%"><span class="Red">*</span>性别</td>
                            <td width="23%">
                                <el-radio-group v-model="reviewInfo.personnel.gender" disabled size="small">
                                    <el-radio label="1">男</el-radio>
                                    <el-radio label="2">女</el-radio>
                                </el-radio-group>
                            </td>
                            <td><span class="Red">*</span>出生年月</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.personnel.birthday" disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>籍贯</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.personnel.native_place" disabled></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>民族</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.personnel.nation" disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>身份证号码</td>
                            <td><el-input size="small" v-model="reviewInfo.personnel.id_card" disabled></el-input></td>
                            <td><span class="Red">*</span>政治面貌</td>
                            <td><el-input size="small" v-model="reviewInfo.personnel.political_party"
                                    disabled></el-input></td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>学历</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.personnel.qualification" disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>学位</td>
                            <td><el-input size="small" v-model="reviewInfo.personnel.degree" disabled></el-input></td>
                            <td><span class="Red">*</span>专业</td>
                            <td><el-input size="small" v-model="reviewInfo.personnel.major" disabled></el-input></td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>技术职称</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.personnel.work_title" disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>工作单位</td>
                            <td colspan="3"><el-input size="small" v-model="reviewInfo.personnel.pf_work"
                                    disabled></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>通信地址</td>
                            <td colspan="5">
                                <div class="TableDis">
                                    <el-input size="small" placeholder="请输入详细地址" v-model="reviewInfo.personnel.address"
                                        disabled></el-input>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>简介</td>
                            <td colspan="5"><el-input size="small" type="textarea" :rows="2"
                                    v-model="reviewInfo.personnel.synopsis" disabled></el-input></td>
                        </tr>
                        <tr>
                            <td>收件人</td>
                            <td><el-input size="small" v-model="reviewInfo.personnel.receiver_name" disabled></el-input></td>
                            <td>收件人联系方式</td>
                            <td><el-input size="small" v-model="reviewInfo.personnel.receiver_mobile" disabled></el-input></td>
                            <td>收件人地址</td>
                            <td><el-input size="small" v-model="reviewInfo.personnel.receiver_address" disabled></el-input></td>
                        </tr>
                    </tbody>
                </table>
                <div class="TitleBox">
                    <span>专业信息</span>
                </div>
                <div class="ZhuanYeWai" v-for="(item, index) in ZhuanYeXinXiInfo" :key="index">
                    <div class="ZhuanYeTheme">{{ item.question_info.name }}</div>
                    
                    <!-- 显示父级问题的答案（如果有的话） -->
                    <div class="ZhuanYeBox" v-if="item.answer">
                        <div class="ZhuanYeBoxInfo">
                            <div>
                                <span v-if="item.question_type == 2">
                                    {{ item.question_info.name }}<span style="color: red;"> {{ item.answer }}</span>{{ item.question_info.unit }}
                                </span>
                                <span v-else>
                                    {{ item.question_info.name }}<span style="color: red;"> {{ item.answer }}</span>
                                </span>
                            </div>
                        </div>
                        <div v-if="item.fileList">
                            <div class="UploadTitle">上传文件:</div>
                            <div class="ZhuanYeBoxFile" v-for="(t, indext) in item.fileList" :key="indext">
                                <div class="FileItem" @click="OpenLock(t)">
                                    <img :title="t.name" :src="$Global._isFileName(t.url)" alt="">
                                    <div :title="t.name" class="FileTitle">{{ t.name }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="item.templatefileList">
                            <div class="UploadTitle">文件:</div>
                            <div class="ZhuanYeBoxFile" v-for="(d, indexd) in item.templatefileList" :key="indexd">
                                <div class="FileItem" @click="OpenLock(d)">
                                    <img :title="d.name" :src="$Global._isFileName(d.url)" alt="">
                                    <div :title="d.name" class="FileTitle">{{ d.name }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- 显示子级问题 -->
                    <div class="ZhuanYeBox" v-for="(items, indexs) in item.children" :key="indexs">
                        <div class="ZhuanYeBoxInfo">
                            <div>
                                <span v-if="items.question_type == 2">
                                    {{ indexs + 1 }}. {{ items.question_info.name }}<span style="color: red;"> {{ items.answer }}</span>{{ items.question_info.unit }}
                                </span>
                                <span v-else>
                                    {{ indexs + 1 }}. {{ items.question_info.name }}<span v-if="items.answer" style="color: red;"> {{ items.answer }}</span>
                                </span>
                            </div>
                        </div>
                        <div v-if="items.fileList">
                            <div class="UploadTitle">上传文件:</div>
                            <div class="ZhuanYeBoxFile" v-for="(t, indext) in items.fileList" :key="indext">
                                <div class="FileItem" @click="OpenLock(t)">
                                    <img :title="t.name" :src="$Global._isFileName(t.url)" alt="">
                                    <div :title="t.name" class="FileTitle">{{ t.name }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="items.templatefileList">
                            <div class="UploadTitle">文件:</div>
                            <div class="ZhuanYeBoxFile" v-for="(d, indexd) in items.templatefileList" :key="indexd">
                                <div class="FileItem" @click="OpenLock(d)">
                                    <img :title="d.name" :src="$Global._isFileName(d.url)" alt="">
                                    <div :title="d.name" class="FileTitle">{{ d.name }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="TitleBox">
                    <span>案例报告</span>
                </div>
                <div class="ZhuanYeBox AnLIBaoGaoBox" v-if="reviewInfo.case && reviewInfo.case.url">
                    <div class="ZhuanYeBoxInfo">
                        <span>1. 案例报告文件</span>
                    </div>
                    <div class="ZhuanYeBoxFile">
                        <div class="FileItem" @click="OpenLock(reviewInfo.case.url)">
                            <img :title="reviewInfo.case.fileName" :src="$Global._isFileName(reviewInfo.case.url)"
                                alt="">
                            <div :title="reviewInfo.case.fileName" class="FileTitle">{{ reviewInfo.case.fileName }}
                            </div>
                        </div>
                    </div>

                    <div class="ZhuanYeBoxInfo" style="margin-top: 20px;">
                        <span>2. 逐字稿文件</span>
                    </div>
                    <div class="ZhuanYeBoxFile" v-if="reviewInfo.case && reviewInfo.case.zixun_url">
                        <div class="FileItem" @click="OpenLock(reviewInfo.case.zixun_url)">
                            <img :title="reviewInfo.case.zixun_fileName" :src="$Global._isFileName(reviewInfo.case.zixun_url)"
                                alt="">
                            <div :title="reviewInfo.case.zixun_fileName" class="FileTitle">{{ reviewInfo.case.zixun_fileName }}
                            </div>
                        </div>
                    </div>

                    <div class="ZhuanYeBoxInfo" style="margin-top: 20px;">
                        <span>3. 专业论文</span>
                    </div>
                    <div class="ZhuanYeBoxFile" v-if="reviewInfo.case && reviewInfo.case.lunwen_url">
                        <div class="FileItem" @click="OpenLock(reviewInfo.case.lunwen_url)">
                            <img :title="reviewInfo.case.lunwen_fileName" :src="$Global._isFileName(reviewInfo.case.lunwen_url)"
                                alt="">
                            <div :title="reviewInfo.case.lunwen_fileName" class="FileTitle">{{ reviewInfo.case.lunwen_fileName }}
                            </div>
                        </div>
                    </div>

                    <div class="ZhuanYeBoxInfo" style="margin-top: 20px;">
                        <span>4. 科普文章1</span>
                    </div>
                    <div class="ZhuanYeBoxFile" v-if="reviewInfo.case && reviewInfo.case.wenzhang1_url">
                        <div class="FileItem" @click="OpenLock(reviewInfo.case.wenzhang1_url)">
                            <img :title="reviewInfo.case.wenzhang1_fileName" :src="$Global._isFileName(reviewInfo.case.wenzhang1_url)"
                                alt="">
                            <div :title="reviewInfo.case.wenzhang1_fileName" class="FileTitle">{{ reviewInfo.case.wenzhang1_fileName }}
                            </div>
                        </div>
                    </div>

                    <div class="ZhuanYeBoxInfo" style="margin-top: 20px;">
                        <span>5. 科普文章2</span>
                    </div>
                    <div class="ZhuanYeBoxFile" v-if="reviewInfo.case && reviewInfo.case.wenzhang2_url">
                        <div class="FileItem" @click="OpenLock(reviewInfo.case.wenzhang2_url)">
                            <img :title="reviewInfo.case.wenzhang2_fileName" :src="$Global._isFileName(reviewInfo.case.wenzhang2_url)"
                                alt="">
                            <div :title="reviewInfo.case.wenzhang2_fileName" class="FileTitle">{{ reviewInfo.case.wenzhang2_fileName }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="TitleBox">
                    <span>推荐信息</span>
                </div>
                <div v-for="(info, infoIndex) in reviewInfo.information" :key="info.id">
                    <div class="ZhuanYeItem" v-if="info.mechanism">
                        <div class="ZhuanYeItemRadio">
                            <label class="radio-label">所在心理服务专业机构</label>
                        </div>
                        <div class="ZhuanYeItemCont">
                            <div class="ZhuanYeItemDis">
                                <div class="ZhuanYeItemFuTit">机构名称</div>
                                <div class="ZhuanYeItemVal"><el-input size="small" disabled
                                        v-model="info.mechanism.name"></el-input></div>
                            </div>
                            <div class="ZhuanYeItemDis">
                                <div class="ZhuanYeItemFuTit">注册码</div>
                                <div class="ZhuanYeItemVal"><el-input size="small" disabled
                                        v-model="info.mechanism.code"></el-input></div>
                            </div>
                        </div>
                    </div>
                    <div class="ZhuanYeItem" v-if="info.tutor">
                        <div class="ZhuanYeItemRadio">
                            <label class="radio-label">注册督导师</label>
                        </div>
                        <div class="ZhuanYeItemCont" v-for="(tutor, index) in info.tutor" :key="index">
                            <div class="ZhuanYeItemTit" v-if="info.tutor.length > 1">注册督导师 {{ index + 1 }}</div>
                            <div class="ZhuanYeItemDis">
                                <div class="ZhuanYeItemFuTit">姓名</div>
                                <div class="ZhuanYeItemVal"><el-input size="small" disabled
                                        v-model="tutor.name"></el-input></div>
                            </div>
                            <div class="ZhuanYeItemDis">
                                <div class="ZhuanYeItemFuTit">注册码</div>
                                <div class="ZhuanYeItemVal"><el-input size="small" disabled
                                        v-model="tutor.code"></el-input></div>
                            </div>
                            <div class="ZhuanYeItemDis">
                                <div class="ZhuanYeItemFuTit">电话</div>
                                <div class="ZhuanYeItemVal"><el-input size="small" disabled
                                        v-model="tutor.mobile"></el-input></div>
                            </div>
                        </div>
                    </div>
                    <div class="ZhuanYeItem" v-if="info.consultant">
                        <div class="ZhuanYeItemCont" v-for="(item, index) in info.consultant" :key="index">
                            <div class="ZhuanYeItemTit">注册心理咨询师 {{ infoIndex + 1 }}</div>
                            <div>
                                <div class="ZhuanYeItemDis">
                                    <div class="ZhuanYeItemFuTit">姓名</div>
                                    <div class="ZhuanYeItemVal"><el-input size="small" disabled
                                            v-model="item.name"></el-input>
                                    </div>
                                </div>
                                <div class="ZhuanYeItemDis">
                                    <div class="ZhuanYeItemFuTit">注册码</div>
                                    <div class="ZhuanYeItemVal"><el-input size="small" disabled
                                            v-model="item.code"></el-input>
                                    </div>
                                </div>
                                <div class="ZhuanYeItemDis">
                                    <div class="ZhuanYeItemFuTit">电话</div>
                                    <div class="ZhuanYeItemVal"><el-input size="small" disabled
                                            v-model="item.mobile"></el-input></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            ReviewBlon: false,
            reviewInfo: {},
            ZhuanYeXinXiInfo: [],
        }
    },
    props: {
        peopleDetails: {
            type: Object, //类型
            required: true, //必要性
            default: {} //默认值
        }
    },
    watch: {
        peopleDetails: {
            handler(newVal, oldVal) {
                this.peopleDetailsInit(newVal);
            },
            // immediate: true,
        }
    },
    methods: {
        peopleDetailsInit(value) {
            console.log('接收到的数据:', value);
            this.reviewInfo = value;
            this.reviewInfo.personnel = value;
            
            // 处理案例报告数据
            if (value.case && value.case.length > 0) {
                this.reviewInfo.case = value.case[value.case.length - 1];
                this.AnLiBaoGaoInit();
            } else {
                // 如果没有案例报告数据，设置为null
                this.reviewInfo.case = null;
            }
            
            // 处理推荐信息
            if (value.information && value.information.length > 0) {
                this.reviewInfo.information = value.information;
                this.TuijianXinxiInit();
            }
            
            // 处理专业信息
            let questionData = null;
            
            // 检查是否有update_question字段（type=1的情况）
            if (value.update_question && value.update_question.length > 0) {
                questionData = value.update_question;
            } else if (value.question && value.question.length > 0) {
                questionData = value.question;
            }
            
            if (questionData) {
                // 检查是否已经有question_info字段（companySearchDetails接口）
                if (questionData[0].question_info) {
                    // 直接处理，不需要额外API
                    this.processQuestionData(questionData);
                } else {
                    // 需要调用API获取题目信息（peopleSearchDetails接口）
                    this.GetFormData();
                }
            }
        },
        
        processQuestionData(questionData) {
            // 按pid分组
            const groupedQuestions = {};
            
            // 先找出所有的父级问题
            const parentQuestions = questionData.filter(q => q.pid === 0);
            
            // 为每个父级问题创建一个组
            parentQuestions.forEach(parent => {
                groupedQuestions[parent.user_question_bank_id] = {
                    question_info: {
                        name: parent.question_info ? parent.question_info.name : `问题组 ${parent.user_question_bank_id}`,
                        type: parent.question_type,
                        unit: parent.question_info ? parent.question_info.unit : ''
                    },
                    children: []
                };
            });
            
            // 将子问题添加到对应的父级问题组中
            questionData.forEach(question => {
                if (question.pid !== 0) {
                    // 找到父级问题组
                    const parentGroup = groupedQuestions[question.pid];
                    if (parentGroup) {
                        // 确保question_info字段存在
                        if (!question.question_info) {
                            question.question_info = {
                                name: `问题 ${question.user_question_bank_id}`,
                                type: question.question_type,
                                unit: ''
                            };
                        }
                        parentGroup.children.push(question);
                    }
                }
            });
            
            // 转换为数组形式
            this.ZhuanYeXinXiInfo = Object.values(groupedQuestions);
            
            // 处理每个问题的文件
            this.ZhuanYeXinXiInit();
        },
        
        GetFormData() {
            // 为peopleSearchDetails接口调用，获取题目信息
            const params = {
                page: 2,
                user_group_id: this.reviewInfo.user_group_id,
            };
            
            // 如果是更新注册，添加type参数
            if (this.reviewInfo.type === 1) {
                params.type = 1;
            }else{
                params.type = 0;
            }
            
            this.$get("api/join_in/getRegisterInformation", params).then(res => {
                if (res.data.code == 1) {
                    // 获取问题列表
                    let question_list = res.data.data[0].question_list;
                    
                    // 确定要处理的数据源
                    let questionData = null;
                    if (this.reviewInfo.update_question && this.reviewInfo.update_question.length > 0) {
                        questionData = this.reviewInfo.update_question;
                    } else if (this.reviewInfo.question && this.reviewInfo.question.length > 0) {
                        questionData = this.reviewInfo.question;
                    }
                    
                    if (!questionData) {
                        console.error('没有找到问题数据');
                        return;
                    }
                    
                    // 创建一个扁平化的题目映射，包含所有父级和子级题目
                    const allQuestionsMap = {};
                    
                    // 先添加父级题目
                    question_list.forEach(parent => {
                        allQuestionsMap[parent.id] = {
                            name: parent.name,
                            type: parent.type,
                            unit: parent.unit
                        };
                        
                        // 再添加子级题目
                        if (parent.children && parent.children.length > 0) {
                            parent.children.forEach(child => {
                                allQuestionsMap[child.id] = {
                                    name: child.name,
                                    type: child.type,
                                    unit: child.unit
                                };
                            });
                        }
                    });
                    
                    console.log('所有题目映射:', allQuestionsMap);
                    
                    // 按pid分组处理问题
                    const groupedQuestions = {};
                    
                    // 先找出所有的父级问题
                    const parentQuestions = questionData.filter(q => q.pid === 0);
                    
                    // 为每个父级问题创建一个组
                    parentQuestions.forEach(parent => {
                        const questionInfo = allQuestionsMap[parent.user_question_bank_id];
                        groupedQuestions[parent.user_question_bank_id] = {
                            question_info: {
                                name: questionInfo ? questionInfo.name : `问题组 ${parent.user_question_bank_id}`,
                                type: parent.question_type,
                                unit: questionInfo ? questionInfo.unit : ''
                            },
                            // 添加父级问题的其他属性
                            answer: parent.answer,
                            question_type: parent.question_type,
                            file: parent.file,
                            templatefile: parent.templatefile,
                            children: []
                        };
                    });
                    
                    // 将子问题添加到对应的父级问题组中
                    questionData.forEach(question => {
                        if (question.pid !== 0) {
                            // 找到父级问题组
                            const parentGroup = groupedQuestions[question.pid];
                            if (parentGroup) {
                                const questionInfo = allQuestionsMap[question.user_question_bank_id];
                                question.question_info = {
                                    name: questionInfo ? questionInfo.name : `问题 ${question.user_question_bank_id}`,
                                    type: question.question_type,
                                    unit: questionInfo ? questionInfo.unit : ''
                                };
                                parentGroup.children.push(question);
                            }
                        }
                    });
                    
                    // 转换为数组形式
                    this.ZhuanYeXinXiInfo = Object.values(groupedQuestions);
                    
                    console.log('处理后的专业信息:', this.ZhuanYeXinXiInfo);
                    
                    // 处理每个问题的文件
                    this.ZhuanYeXinXiInit();
                } else {
                    this.$message.error(res.data.msg)
                }
            }).catch(err => {
                console.error('获取问题信息失败:', err);
                this.$message.error('获取问题信息失败，请重试');
            });
        },
        
        AnLiBaoGaoInit() {
            // 检查case是否存在
            if (!this.reviewInfo.case) {
                console.log('没有案例报告数据');
                return;
            }
            
            // 处理案例报告文件
            if (this.reviewInfo.case.file) {
                this.reviewInfo.case.fileName = this.reviewInfo.case.file.split('\/').pop();
                this.reviewInfo.case.type = this.reviewInfo.case.file.split('\.').pop();
                this.reviewInfo.case.url = {
                    url: this.reviewInfo.case.file
                };
            }

            // 处理逐字稿文件
            if (this.reviewInfo.case.zixun_file) {
                this.reviewInfo.case.zixun_fileName = this.reviewInfo.case.zixun_file.split('\/').pop();
                this.reviewInfo.case.zixun_url = {
                    url: this.reviewInfo.case.zixun_file
                };
            }

            // 处理专业论文
            if (this.reviewInfo.case.lunwen_file) {
                this.reviewInfo.case.lunwen_fileName = this.reviewInfo.case.lunwen_file.split('\/').pop();
                this.reviewInfo.case.lunwen_url = {
                    url: this.reviewInfo.case.lunwen_file
                };
            }

            // 处理科普文章1
            if (this.reviewInfo.case.wenzhang1_file) {
                this.reviewInfo.case.wenzhang1_fileName = this.reviewInfo.case.wenzhang1_file.split('\/').pop();
                this.reviewInfo.case.wenzhang1_url = {
                    url: this.reviewInfo.case.wenzhang1_file
                };
            }

            // 处理科普文章2
            if (this.reviewInfo.case.wenzhang2_file) {
                this.reviewInfo.case.wenzhang2_fileName = this.reviewInfo.case.wenzhang2_file.split('\/').pop();
                this.reviewInfo.case.wenzhang2_url = {
                    url: this.reviewInfo.case.wenzhang2_file
                };
            }
        },
        
        TuijianXinxiInit() {
            this.reviewInfo.information.forEach(info => {
                if (info.tutor) {
                    info.tutor = JSON.parse(info.tutor);
                    if (!Array.isArray(info.tutor)) {
                        info.tutor = [info.tutor];
                    }
                }
                if (info.mechanism) {
                    info.mechanism = JSON.parse(info.mechanism);
                }
                if (info.consultant) {
                    let consultantData = JSON.parse(info.consultant);
                    if (!Array.isArray(consultantData)) {
                        consultantData = [consultantData];
                    }
                    info.consultant = consultantData;
                }
            });
        },
        
        ZhuanYeXinXiInit() {
            // 处理专业信息中的文件
            this.ZhuanYeXinXiInfo.forEach(item => {
                if (item.children && item.children.length > 0) {
                    item.children.forEach(items => {
                        // 确保question_type和question_info.type一致
                        if (items.question_info && items.question_info.type) {
                            // 将字符串类型转换为数字类型，以便于在模板中比较
                            if (typeof items.question_info.type === 'string') {
                                items.question_info.type = parseInt(items.question_info.type) || 0;
                            }
                        }
                        
                        // 处理文件
                        try {
                            if (items.file && items.file !== '[]' && typeof items.file === 'string') {
                                items.fileList = JSON.parse(items.file);
                            }
                            if (items.templatefile && items.templatefile !== '[]' && typeof items.templatefile === 'string') {
                                items.templatefileList = JSON.parse(items.templatefile);
                            }
                        } catch (e) {
                            console.error('解析文件数据出错:', e);
                        }
                    });
                }
            });
            
            console.log('处理后的专业信息:', this.ZhuanYeXinXiInfo);
        },
        
        handleClick(t) {
            let text = '网盘地址:' + t.video_file + '网盘密码:' + t.password;
            this.$copyText(text).then(() => {
                this.$message.success('复制成功');
            }).catch(() => {
                this.$message.warning('复制失败');
            });
        },
        OpenLock(res) {
            this.$Global.previewFile(res)
        },
        OpenWeb(res) {
            window.open(res)
        },
        OpenReviewBlon() {
            this.ReviewBlon = true
        },
    }
}
</script>
<style scoped>
.CommDig {
    max-height: 600px;
    overflow: auto;
}

.Table {
    width: 99%;
    margin: 10px auto;
    border-radius: 5px;
    border-collapse: collapse;
}

.Table td {
    border: 1px solid #e4eaec;
    padding: 10px;
    font-weight: 400;
    font-size: 16px;
    color: #666;
}

.Table .State {
    padding-right: 10px;
}

.Table .Th {
    color: #000000;
    font-size: 16px;
    padding: 10px;
    font-weight: 700;
}

.Table td .Red {
    color: #d51938;
    font-weight: 700;
    vertical-align: middle;
    /* margin-right: 10px; */
}

.Table .TableDis {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.WidMax {
    width: 100%;
}

.TitleBox {
    width: 100%;
    height: 40px;
    background-color: #0385EB;
    line-height: 42px;
    margin-top: 10px;
    padding-left: 15px;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    color: #ffffff;
    box-sizing: border-box;
}

.ZhuanYeWai .ZhuanYeTheme {
    font-size: 16px;
    font-weight: 600;
    margin: 10px 0;
}

.ZhuanYeBox {
    font-size: 16px;
    background-color: #F5F5F5;
    padding: 20px;
    margin-bottom: 10px;
}

.ZhuanYeBox .UploadTitle {
    font-size: 16px;
}

/* .ZhuanYeBox .ZhuanYeBoxInfo {
    margin-top: 20px;
} */

.ZhuanYeBoxFile {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 10px 10px 0 10px;
    border: 1px #0385EB solid;
    box-sizing: border-box;
}

.ZhuanYeBoxFile .FileItem {
    cursor: pointer;
    width: 90px;
    font-size: 14px;
    padding: 0 10px 10px 0;
}

.ZhuanYeBoxFile .FileItem .FileTitle {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 15px;
    width: 90px;
    margin-top: 2px;
}

.ZhuanYeBoxFile .FileItem img {
    width: 90px;
    height: 90px;
}

.AnLIBaoGaoBox {
    margin-top: 20px;
}

.ZhuanYeItem {
    width: 500px;
}

.ZhuanYeItemRadio {
    margin-top: 10px;
}

.ZhuanYeItemRadio .radio-label {
    font-weight: 600;
    font-size: 16px;
}

.ZhuanYeItemTit {
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    padding: 10px 0;
}

.ZhuanYeItemDis {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.ZhuanYeItemCont {
    width: 75%;
    margin: 10px 0 0 10px;
}

.ZhuanYeItemFuTit {
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    width: 30%;
}

.ZhuanYeItemVal {
    margin-left: 20px;
    flex: 1;
}

.SupervisorBox {
    padding-left: 20px;
}

.SpanColorRed {
    color: red;
}
</style>
<style>
.ProfessionalProfessional .el-dialog__body {
    padding: 0 20px 20px 20px;
}
</style>